import { useState } from 'react';

import { usePreferencesStore } from '#lib/stores/preferencesStore';

const MIN_WIDTH = 120;
const MAX_WIDTH = 800;

const clamp = (width) => Math.round(Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, width)));

/**
 * Width of the first column as dragged by the user. Persisted per `layoutKey`; tables without
 * one keep it until reload. While dragging only local state changes, so localStorage is
 * written once on release.
 *
 * @param {string|undefined} layoutKey
 * @returns {{width: number|null, onResize: Function, onResizeEnd: Function, onReset: Function}}
 *   `width` null = the column's own default.
 */
export function useFirstColumnWidth(layoutKey) {
	const saved = usePreferencesStore((s) => (layoutKey ? s.tableFirstColumnWidths?.[layoutKey] : undefined));
	const setSaved = usePreferencesStore((s) => s.setTableFirstColumnWidth);
	const [draft, setDraft] = useState(null);

	const onResizeEnd = (width) => {
		if (!layoutKey) return setDraft(clamp(width));
		setSaved(layoutKey, clamp(width));
		setDraft(null);
	};
	const onReset = () => {
		setDraft(null);
		if (layoutKey) setSaved(layoutKey, null);
	};

	return {
		width: draft ?? saved ?? null,
		onResize: (width) => setDraft(clamp(width)),
		onResizeEnd,
		onReset,
	};
}
